import { SelectedPolySymbol } from "./SelectedPolySymbol";
import { SelectedPointSymbol } from "./SelectedPointSymbol";

export const DEFAULT_SELECTED_POINT_OPTIONS = {
  size: 12,
  strokeWidth: 2,
  strokeColor: "rgba(255, 255, 255, 0.5)",
  fillColor: "rgba(228, 57, 4, 0.5)",
  shadowColor: "rgba(228, 57, 4, 0.5)",
  shadowSize: 6,
  selectedStrokeColor: "#fff",
  selectedFillColor: "#E43904",
};

export const DEFAULT_SELECTED_POLYLINE_OPTIONS = {
  strokeWidth: 2,
  strokeColor: "rgba(228, 57, 4, 0.5)",
  shadowSize: 4,
  shadowColor: "#fff",
  outerShadowColor: "rgba(228, 57, 4, 0.5)",
  outerShadowSize: 8,
  selectedStrokeColor: "#E43904",
  selectedStrokeWidth: 2,
};

export const DEFAULT_SELECTED_POLYGON_OPTIONS = {
  strokeWidth: 2,
  strokeColor: "rgba(255, 255, 255, 0.5)",
  shadowSize: 12,
  shadowColor: "rgba(228, 57, 4, 0.5)",
  fillColor: "rgba(228, 57, 4, 0.5)",
  enclose: true,
  selectedFillColor: "#E43904",
  selectedStrokeColor: "#fff",
};

export const selectedPoint = new SelectedPointSymbol(DEFAULT_SELECTED_POINT_OPTIONS);

export const selectedPolyline = new SelectedPolySymbol(DEFAULT_SELECTED_POLYLINE_OPTIONS);

export const selectedPolygon = new SelectedPolySymbol(DEFAULT_SELECTED_POLYGON_OPTIONS);
